{
  "achievementCenter": "مركز الإنجازات",
  "achievementCenterSubtitle": "افتح الشارات، اكسب XP، ارفع مستواك وابنِ هويتك في Exalt Exchange.",
  "badges": "الشارات",
  "bearish": "هابط",
  "bullish": "صاعد",
  "buy": "شراء",
  "comment": "تعليق",
  "commentAddedSuccessfully": "تمت إضافة التعليق بنجاح.",
  "commentFailed": "فشل التعليق",
  "communityFeed": "منشورات المجتمع",
  "communityPosts": "منشورات المجتمع",
  "completedTrades": "الصفقات المكتملة",
  "copyCode": "نسخ الرمز",
  "copyLink": "نسخ الرابط",
  "createSignalPost": "إنشاء إشارة / منشور سوق",
  "currentLevel": "المستوى الحالي",
  "displayName": "اسم العرض",
  "disputes": "النزاعات",
  "exaltTrader": "متداول EXALT",
  "failedCreatePost": "فشل إنشاء المنشور",
  "failedLoadAchievements": "فشل تحميل الإنجازات.",
  "failedLoadReputation": "فشل تحميل السمعة.",
  "failedLoadSocialTrading": "فشل تحميل التداول الاجتماعي",
  "failedRefreshAchievements": "فشل تحديث الإنجازات.",
  "failedRefreshReputation": "فشل تحديث السمعة.",
  "follow": "متابعة",
  "followFailed": "فشل المتابعة",
  "followers": "المتابعون",
  "following": "يتابع",
  "fraudFlags": "علامات الاحتيال",
  "goldBadges": "شارات ذهبية",
  "joinExaltUsingReferral": "انضم إلى Exalt Exchange باستخدام رمز الإحالة الخاص بي وابدأ التداول.",
  "joined": "تاريخ الانضمام",
  "levelProgress": "تقدم المستوى",
  "levelProgressText": "استمر في كسب نقاط الخبرة للوصول إلى المستوى التالي.",
  "like": "إعجاب",
  "likeFailed": "فشل الإعجاب",
  "loading": "جاري التحميل...",
  "loadingAchievementCenter": "جارٍ تحميل مركز الإنجازات...",
  "loadingQr": "جارٍ تحميل رمز الاستجابة السريعة...",
  "loadingReputationCenter": "جارٍ تحميل مركز السمعة...",
  "loadingSocialTrading": "جاري تحميل التداول الاجتماعي...",
  "locked": "مغلق",
  "low": "منخفض",
  "myTraderProfile": "ملفي كمتداول",
  "neutral": "محايد",
  "noAchievementProfileFound": "لم يتم العثور على ملف إنجازات.",
  "noBadgesYet": "لا توجد شارات بعد. زد نشاطك لفتح الشارات.",
  "noPostsYet": "لا توجد منشورات بعد.",
  "noReferralRewardsYet": "لا توجد مكافآت إحالة بعد.",
  "noReferredMembersYet": "لم تقم بإحالة أي شخص بعد.",
  "noReputationHistoryYet": "لا يوجد سجل سمعة بعد.",
  "noReputationProfileFound": "لم يتم العثور على ملف سمعة.",
  "noTraders": "لم يتم العثور على متداولين.",
  "noTradersFound": "لا يوجد متداولون.",
  "p2pOrders": "طلبات P2P",
  "p2pRating": "تقييم P2P",
  "pair": "الزوج",
  "platinum": "بلاتيني",
  "postCreatedSuccessfully": "تم إنشاء المنشور بنجاح.",
  "posting": "جاري النشر...",
  "previous": "السابق",
  "profitLoss": "الأرباح / الخسائر",
  "publishPost": "نشر المنشور",
  "referralCodeCopied": "تم نسخ رمز الإحالة.",
  "referralLinkCopied": "تم نسخ رابط الإحالة.",
  "referralLoadFailed": "فشل تحميل بيانات الإحالة.",
  "referralQrCode": "رمز QR للإحالة",
  "referralReward": "مكافأة الإحالة",
  "referralRewardHistory": "سجل مكافآت الإحالة",
  "referredUser": "المستخدم المُحال",
  "refreshAchievements": "تحديث الإنجازات",
  "refreshScore": "تحديث النتيجة",
  "reputationCenter": "نظام سمعة المجتمع",
  "reputationCenterSubtitle": "ابنِ هويتك في Exalt من خلال الثقة في التداول ونجاح P2P والشارات الموثقة ونشاط المجتمع.",
  "reputationHistory": "سجل السمعة",
  "reputationScore": "درجة السمعة",
  "searchYourMembers": "ابحث عن أعضائك بالاسم أو البريد الإلكتروني",
  "sell": "بيع",
  "send": "إرسال",
  "sentiment": "المشاعر",
  "serverError": "خطأ في الخادم.",
  "sessionExpired": "انتهت الجلسة. الرجاء تسجيل الدخول مرة أخرى.",
  "shareMarketViewPlaceholder": "شارك رأيك في السوق أو إعداد التداول أو تحديث EXALT أو إشارة...",
  "shareReferralLink": "مشاركة رابط الإحالة",
  "signal": "الإشارة",
  "socialTradingSubtitle": "تابع المتداولين الخبراء، شارك أفكار السوق، شاهد الإشارات وانمُ مع مجتمع تداول EXALT.",
  "socialTradingTitle": "التداول الاجتماعي",
  "topTraders": "أفضل المتداولين",
  "topTradersLeaderboard": "لوحة أفضل المتداولين",
  "totalComments": "إجمالي التعليقات",
  "totalEarnings": "إجمالي الأرباح",
  "totalLikes": "إجمالي الإعجابات",
  "totalReferrals": "إجمالي الإحالات",
  "totalTraders": "إجمالي المتداولين",
  "totalXp": "إجمالي XP",
  "tradeType": "نوع الصفقة",
  "tradingSuccess": "نجاح التداول",
  "unfollow": "إلغاء المتابعة",
  "unlocked": "مفتوح",
  "username": "اسم المستخدم",
  "verified": "موثق",
  "winRate": "معدل الفوز",
  "writeBeforePosting": "يرجى كتابة شيء قبل النشر.",
  "writeComment": "اكتب تعليقاً...",
  "yourReferralCode": "رمز الإحالة الخاص بك",
  "yourReferralLink": "رابط الإحالة الخاص بك",
  "yourReferredMembers": "الأعضاء الذين أحلتهم"
}